import { CountryCode } from "config/BaseConfig";
import { Button as RSuiteButton } from "rsuite";
import classes from "./SecondaryButton.module.scss";
import CHEVRON_ICON from "../../../assets/img/chevron-right-solid.svg";

interface ButtonProps {
  text: string;
  onClick: () => Promise<void>;
  isLoading: boolean;
}

const SecondaryButton = ({ text, onClick, isLoading = false }: ButtonProps) => {
  return (
    <RSuiteButton
      loading={isLoading}
      className={
        CountryCode === "US" ? classes.main_css_us : classes.main_css_jp
      }
      onClick={onClick}
    >
      {text}
      <img src={CHEVRON_ICON} alt="矢印" style={{width: '11px', height: '17px'}} />
    </RSuiteButton>
  );
};
export default SecondaryButton;
